import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Loader2, CheckCircle2 } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";
import { useEntitlements } from "../hooks/useEntitlements";
import { Button } from "../components/ui/button";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "../components/ui/card";
import ClinicalThemeToggle from "../components/ClinicalThemeToggle";

const CheckoutSuccessPage = () => {
  const { t } = useLanguage();
  const { entitlements, loading, refresh } = useEntitlements();

  useEffect(() => {
    const timer = setInterval(refresh, 3000);
    return () => clearInterval(timer);
  }, [refresh]);

  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center p-6">
      <div className="absolute top-4 right-4">
        <ClinicalThemeToggle />
      </div>
      <Card className="max-w-md w-full">
        <CardHeader className="text-center">
          <CheckCircle2 className="w-12 h-12 text-primary mx-auto mb-2" />
          <CardTitle>{t("billing.successTitle")}</CardTitle>
          <CardDescription>{t("billing.successDesc")}</CardDescription>
        </CardHeader>
        <CardContent className="space-y-4 text-center">
          {loading ? (
            <Loader2 className="w-6 h-6 animate-spin mx-auto text-muted-foreground" />
          ) : entitlements ? (
            <p className="text-sm text-muted-foreground">
              {t("billing.successBalance")
                .replace("{free}", String(entitlements.free_cases_remaining ?? 0))
                .replace("{paid}", String(entitlements.paid_cases_remaining ?? 0))
                .replace("{sub}", String(entitlements.subscription_cases_remaining ?? 0))}
            </p>
          ) : null}
          <Button asChild>
            <Link to="/case/new">{t("billing.backToCases")}</Link>
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};

export default CheckoutSuccessPage;
